import { defined } from '../utils/functions.js';
import { ConnectionEditing, SOURCE, TARGET } from '../constants.js';

class ConnectionEditUnit {
    constructor(item, redoSource, redoTarget) {
        this.item = item;
        this._redoSource = redoSource;
        this._redoTarget = redoTarget;
        if (defined(redoSource)) {
            this._undoSource = item.source();
        }
        if (defined(redoTarget)) {
            this._undoTarget = item.target();
        }
        this.title = ConnectionEditing;
    }
    undo() {
        if (this._undoSource !== undefined) {
            this.item._updateConnector(this._undoSource, SOURCE);
        }
        if (this._undoTarget !== undefined) {
            this.item._updateConnector(this._undoTarget, TARGET);
        }
        this.item.updateModel();
    }
    redo() {
        if (this._redoSource !== undefined) {
            this.item._updateConnector(this._redoSource, SOURCE);
        }
        if (this._redoTarget !== undefined) {
            this.item._updateConnector(this._redoTarget, TARGET);
        }
        this.item.updateModel();
    }
}

export { ConnectionEditUnit };
